export default {
    menu: 'Telegram-Bots',
    trades: 'Trades',
    messages: 'Nachrichten',
    bots: 'Bots',
    orders: 'Orders',

}
